import { isElectron, isLocal } from '@baeso-ui/baeso-core';
export const TRACING_API_SPAN = isElectron() || isLocal() ? process.env.REACT_APP_SERVICE_ELECTRON_BASEURL + '/api/v2/spans' : '/api/v2/spans';
export const AUTHENTICATION_ADDRESS = isElectron() || isLocal() ? process.env.REACT_APP_SERVICE_ELECTRON_BASEURL + '/auth/' : '/auth/';
export const AUTHENTICATION_REALM = 'onacta';
export const CLIENT_ID = 'onacta-frontend';
export const DEV_MODE = false;
